<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false"  />
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <el-col :span="24" class="content-right" >
                    <div class="main-view">
                        <div class="dialog-view" v-loading="loading">
                            <div class="view-top">
                            </div>
                            <div class="view-search">
                                <el-form :inline="true" :model="searchForm" ref="searchForm">
                                    <el-form-item class="search-item" prop="searchType">
                                        <el-select v-model="searchForm.searchType" placeholder="选择变更类型" size="small" clearable>
                                            <el-option v-for="(item)  in searchTypearr"  :key="item.key" :label="item.value" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!-- <el-form-item class="search-item" prop="searchPerson">
                                        <el-select v-model="searchForm.searchPerson" placeholder="选择变更人" size="small" clearable>
                                            <el-option v-for="(item)  in searchPersonarr"  :key="item.key" :label="item.value" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item> -->
                                    <el-form-item class="search-item" prop="searchState">
                                        <el-select v-model="searchForm.searchState" placeholder="选择变更状态" size="small" clearable>
                                            <el-option v-for="(item)  in searchPersonarr"  :key="item.key" :label="item.value" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item class="search-item" style="width:60px;">
                                        <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                                    </el-form-item>
                                    <el-form-item class="search-item" style="width:60px;">
                                        <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="search-table">
                                <el-table
                                    :data="tableData"
                                    style="width: 100%"
                                    tooltip-effect="dark"
                                    empty-text="暂无数据"
                                    border
                                    show-header
                                    :default-sort = "{prop: 'createTime', order: 'descending'}"
                                    >
                                    <el-table-column
                                    label="变更类型"
                                    align="center"
                                    show-overflow-tooltip
                                    width="150">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.changeType == '1'">活动执行日期</span>
                                        <span v-if="scope.row.changeType == '2'">售点</span>
                                        <span v-if="scope.row.changeType == '3'">售点和活动执行日期</span>
                                    </template>
                                    </el-table-column>

                                    <el-table-column
                                    label="变更人"
                                    align="center"
                                    width="80">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.updateType == '0'">供应商</span>
                                        <span v-if="scope.row.updateType == '1'">TM</span>
                                    </template>
                                    </el-table-column>

                                    <el-table-column
                                    :label="pocRelateType == '0' ? '变更后活动地点 ' : '变更后售点'"
                                    align="center"
                                    width="200"
                                    show-overflow-tooltip
                                    >
                                    <template slot-scope="scope">
                                        <span v-if="pocRelateType == '0'">
                                            <span v-if="scope.row.newBlockVO">
                                                <span v-if="scope.row.newBlockVO.blockName"> {{ scope.row.newBlockVO.blockName }}</span>
                                                <span></span>
                                            </span>
                                            <span v-else></span>
                                           </span>
                                        <span v-else-if="pocRelateType == '1'">{{ getSalename(scope.row.newPocList) }}</span>
                                        <div v-else-if="pocRelateType == '2'" style="overflow: hidden;word-wrap: break-word;word-break: break-all;">
                                            <div v-if="scope.row.newBlockVO">街区名称：{{ scope.row.newBlockVO.blockName }}</div>
                                            <div v-if="scope.row.newPocList">售点名称：{{ getSalename(scope.row.newPocList) }}</div>
                                        </div>
                                    </template>
                                    </el-table-column>

                                    <el-table-column
                                    prop="activityTimeNew"
                                    label="变更后活动执行日期"
                                    align="center"
                                    width="200"
                                    >
                                    <!-- show-overflow-tooltip -->
                                    <template slot-scope="scope">
                                        <span>{{ changeTimename(scope.row.timeNewList) }}</span>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    align="center"
                                    show-overflow-tooltip
                                    label="变更理由"
                                    >
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.changeReason">{{ scope.row.changeReason }}</span>
                                        <span v-else></span>
                                    </template>
                                    </el-table-column>

                                    <el-table-column
                                    label="变更状态"
                                    align="center"
                                    width="80"
                                    show-overflow-tooltip
                                    >
                                    <template slot-scope="scope">
                                        <span>变更成功</span>
                                    </template>
                                    </el-table-column>

                                    <el-table-column
                                    prop="createTime"
                                    label="变更时间"
                                    align="center"
                                    sortable
                                    show-overflow-tooltip
                                    width="180">
                                    <template slot-scope="scope">
                                        <span>{{changeUpdatetime(scope.row.createTime)}}</span>
                                        <!-- <span>{{changeUpdatetime(1683803634076)}}</span> -->
                                    </template>
                                    </el-table-column>

                                    <el-table-column
                                    align="center"
                                    show-overflow-tooltip
                                    label="操作"
                                    >
                                    <template slot-scope="scope">
                                        <div style="color:#4E73F9;cursor: pointer;" @click="viewImage(scope.row)">查看详情</div>
                                    </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <!-- <div class="search-bottom" v-if="tableData.length > 0">
                                <el-pagination
                                    background
                                    :total="searchForm.total"
                                    layout="total, prev, pager, next"
                                    :current-page="searchForm.page"
                                    :page-size="searchForm.pageSize"
                                    @current-change="handleCurrentChange">
                                    <span style="text-align: center">{{searchForm.page}}/{{searchForm.allPage}}</span>
                                </el-pagination>
                            </div> -->
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import gameplanApi from '../../api/gameplan'
    export default {
      name: 'activity-history',
      components: {
        ContentHeader,
      },
      data () {
        return {
            loading: false,
            tableData: [],
            searchForm: {
                searchType: null,
                searchPerson: null,
                searchState: null,
                page: 1,
                pageSize: 5,
                total: 20,
                allPage: 4,
            },
            searchTypearr: [
                {'key':2,'value':"售点"},
                {'key':1,'value':"活动执行日期"},
                {'key':3,'value':"活动执行日期和售点"},
            ],
            searchPersonarr: [
                {'key':4,'value':"变更成功"},
            ],
            activityId:'',
            pocRelateType:''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),

      },
      watch: {
      },
      created () {
        this.init()
      },
      mounted () {
      },
      methods: {
        init () {
            this.activityId = this.$route.query.activityId
            this.pocRelateType = this.$route.query.pocRelateType
            this.getTablelist()
        },
        viewImage (item) {
            let detailItem = JSON.stringify(item)
            // this.$router.push(
            //     {path:'/gameplan/activity-history-detail',
            //     query:{
            //         'changeApprovalId':1056,
            //         'activityId':2013,
            //         'detailItem':detailItem,
            //         'pocRelateType':this.pocRelateType}
            //     }
            //     )
            this.$router.push({path:'/gameplan/activity-history-detail',query:{
                'changeApprovalId':item.timeApprovalId,
                'pocRelateType':this.pocRelateType,
                'activityId':item.activityId,
                'detailItem':detailItem,
            }})
        },
        getSalename (arr) {
            if (arr) {
                let name = arr.map((item)=>{
                    return item.pocName
                }).join(' | ')
                return name
            } else {
                return ''
            }
        },
        changeTimename (arr) {
            if (arr) {
                let name = arr.map((item)=>{
                    return item
                }).join(' | ')
                return name
            } else {
                return ''
            }
        },
        changeUpdatetime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D + '' + h + m + s
        }
        },
        async getTablelist () {
            this.loading = true
            let params = {
                'activityId':this.activityId,
                'changeType':this.searchForm.searchType,
                // 'changeType':'1',
                'searchPerson':this.searchForm.searchPerson,
                'searchState':this.searchForm.searchState,
            }
            let res = await gameplanApi.hitoryChangelist(params);
            if (res.data.resultCode == "0") {
                this.loading = false
                this.tableData = res.data.resultData.changeList
                // console.log(res.data.resultData,'resultData');
                // console.log(this.tableData,'tableData');
            } else {
                this.loading = false
            }
        },
        queryForm () {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    // this.searchForm.page = 1
                    this.getTablelist()
                } else {
                    return false;
                }
            });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            // this.searchForm.page = 1
            this.getTablelist()
        },
        handleCurrentChange (val) {
            this.searchForm.page = val
        },
        // 活动详情-查看
        activityDetail (item) {
            this.$router.push({path:'/gameplan/activity-report-detail',query:{'activityId':item.activityId,'themeDetailId':item.themeDetailId,'typeStatus':item.activityStatus,'routerType':'view'}})
        },
      }
    }
</script>
<style lang="scss" scoped>
    .el-menu-item.is-active {
        // color: #fff;
        border: none;
        font-weight: bold;
        // background-color: rgba(51, 51, 51, 0.2) !important;
    }
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .trade-nav-panel {
      width: 80%;
      margin: 0 auto;
      background: $base-white;
      .el-menu-item:last-child{
        border-bottom: 0;
      }
      ::v-deep .el-card__header {
        height: 70px;
        line-height: 35px;
      }
      ::v-deep .el-card__body {
        padding: 0;
      }
      .panel-header {
        font-size: 16px;
        font-weight: 700;
        color:#CD1231;
      }
      ::v-deep .el-menu {
        border-right: 0;
      }
      ::v-deep .el-menu-item {
        border-bottom: 1px solid $base-grey5;
      }
      ::v-deep .el-menu-item.is-active {
        color: $base-red;
      }
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            .searchForm {
                margin: auto;
                width: 1000px;
                .item {
                    width:105px;
                }
                .item-btn {
                    margin-left: 30px;
                }
            }
        }
        .top-btn {
            padding: 0px 0px 10px 0px;
            font-size: 14px;
            text-align: right;
            margin: auto;
            width: 1000px;
            .btn-left {
                height: 32px;
                padding: 4px 12px;
                border-radius: 4px;
                border: 1px solid #CD1231;
                background-color: #FFFFFF;
                color: #CD1231;
                cursor: pointer;
            }
            .btn-right {
                height: 32px;
                padding: 4px 12px;
                border-radius: 4px;
                border: 1px solid #CD1231;
                background-color: #CD1231;
                color: #FFFFFF;
                margin-left: 15px;
                cursor: pointer;
            }
        }
        .main-view {
            margin: auto;
            width: 1080px;
            .view-search {
                display: flex;
                margin-bottom: 10px;
                .search-item {
                    width: 190px;
                    line-height: 40px;
                    margin: 0px 10px 0px 0px;
                }
            }
            .search-table {
                ::v-deep .el-table th.el-table__cell {
                    color: #101010;
                    background-color: rgba(232, 232, 232);
                }
                ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                    background-color: #FFFFFF !important;
                }
                ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                    background-color: #FFFFFF !important;
                }

            }
            .search-bottom {
                // position: relative;
                // top: 20px;
                margin: 20px 0px 0px 0px;
                text-align: center;
                ::v-deep .el-pagination.is-background .btn-next,
                ::v-deep .el-pagination.is-background .btn-prev{
                    background-color: #FFFFFF;
                    color: #000;
                    border: 1px solid #C0C4CC;
                    border-radius: 3px;
                }
                ::v-deep .el-pagination.is-background .btn-next:disabled,
                ::v-deep .el-pagination.is-background .btn-prev:disabled,
                ::v-deep .el-pagination.is-background .el-pager li.disabled {
                    color: #C0C4CC;
                }
            }
        }
      }
      .content-left {
        padding-right: $content-middle;
      }
    }
</style>
